/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ month: NonNullable<unknown>, year: NonNullable<unknown> }} Billing_Payment_ExpiresInputs */



/**
* | output |
* | --- |
* | "Expires {month}/{year}" |
*
* @param {Billing_Payment_ExpiresInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const billing_payment_expires = /** @type {((inputs: Billing_Payment_ExpiresInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Payment_ExpiresInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Läuft ab ${i?.month}/${i?.year}`)
	return /** @type {LocalizedString} */ (`Expires ${i?.month}/${i?.year}`)
});